import { CustomPageHeader, Text } from '@src/components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import BalanceReportFilter from './BalanceReportFilter';
import BalanceReportList from './BalanceReportList';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

const BalanceReport = ({ isCompliments = false, isMarket = false }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  let header;
  let vouId;
  let segId;

  if (isMarket) {
    vouId = VouIdCode.Market;
    header = 'Ticket Market';
    segId = 1100;
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
    header = 'Ticket Gift';
    segId = 9400;
  } else {
    vouId = VouIdCode.Restaurant;
    header = 'myInvoices';
    segId = 1000;
  }

  return (
    <CustomPageHeader
      data-testid="manage-my-cards"
      title={<Text t="balanceReport" />}
      showBreadCrumb
      showHelpButton
      routes={[header]}
    >
      <BalanceReportFilter segId={segId} vouId={vouId} form={form} />
      <BalanceReportList segId={segId} vouId={vouId} form={form} />
    </CustomPageHeader>
  );
};

BalanceReport.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};

export default BalanceReport;
